import { arrayCreate } from '../common.type';
import { useMemo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2vmin;
  margin: 1vmin;
`;
const Try = styled.button`
  cursor: pointer;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  width: ${(props) => `4${props.theme.unit}`};
  height: ${(props) => `4${props.theme.unit}`};
  font-size: ${(props) => `4.5${props.theme.unit}`};
  line-height: 1;
  border-radius: 50%;
  color: #fff;

  &:disabled {
    cursor: default;
  }
`;
export const Tries = ({
  current,
  max,
  onClick,
}: {
  current: number;
  max: number;
  onClick?: (tries: number) => void;
}) => {
  const arrayTries = useMemo(() => {
    return arrayCreate(max);
  }, [max]);

  return (
    <Wrapper>
      {arrayTries.map((_v, i) => {
        return (
          <Try
            key={i}
            onClick={() => {
              if (onClick) {
                onClick(i + 1);
              }
            }}
            disabled={!onClick}
            aria-disabled={!onClick}
            aria-pressed={i + 1 <= current}
          >
            {i + 1 <= current && <>&times;</>}
          </Try>
        );
      })}
    </Wrapper>
  );
};
